<template>
  <div class="device-ct">
    <PullDown v-if="!hidePullDown" style="margin-top: 0;"></PullDown>
    <div class="nav">
      <div class="module-title">
        <h1>超声教学实训设备</h1>
      </div>

      <div class="ct-content">
        <div class="single-col-card">
          <!-- 文字描述区域 -->
          <div class="text-wrap">
            <p class="text-content">{{ p[0] }}</p>
            <p class="text-content">{{ p[1] }}</p>
          </div>

          <!-- 顶部图片缩略组件 -->
          <ImgCol :imgList="img.slice(0,3)"></ImgCol>

          <!-- 功能分类卡片组件 -->
          <CardBorder :h6="h6" :msg="p.slice(2)" :img="img.slice(3)"></CardBorder>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImgCol from "@/components/imgCol.vue"
import CardBorder from "./cardBorder.vue"
import PullDown from "@/components/home/pullDown.vue"

export default {
  props: {
        hidePullDown: {
            type: Boolean,
            default: false // 默认显示
        }
    },
  name: "SuperSoundTrain",
  components: {
    ImgCol,
    CardBorder,
    PullDown
  },
  data(){
    return{
      wWidth: window.innerWidth,
      p:[
        '超声模拟实训系统是一款全面的超声教学、示范教学训练系统，系统使用1:1仿真人体模型，实时精准捕捉模拟超声探头及仿真人体模型的相对位置，同步显示相应的3D解剖模型及模拟超声图像，通过虚拟仿真技术将人体结构及超声图像同时呈现。练习手眼协调和探头操作，提高标准切面和疾病的识别能力。具有超声教学中的颈部、腹部、心脏等多项超声检查的训练功能，提供多样化的超声训练内容，丰富的真实案例。系统具有教学、训练、切面测评三大功能，可全面、多角度培养学生超声操作技能。',
        '产品特点：动态显示，实时同步；病例多样，支持拓展；模型精准，持久耐用；超声效果逼真；解剖结构逼真；功能参数全面。',
        '',
        '调节超声图像上显示的纵向距离。',
        '调节各模式下的增益，增加信号灵敏度。',
        '进入体位图工作状态，可选择对应部位的体表图添加到超声图像上。',
        '调节彩色血流和频谱多普勒的速度显示范围，优化血流和频谱的图像质量。调节频谱中速度轨迹上为零的点，以容纳更快和更慢的血流，以消除混淆。',
        '旋转角度校正线来确定角度值，尽量与血流方向平行，角度大小须在±60°范围内。',
        '在冻结时测量，激活测量标尺，显示相应模式下测量菜单。',
      ],
      img:[
        require("@/assets/supersound1.png"),
        require("@/assets/supersound2.png"),
        require("@/assets/supersound3.png"),
        [require("@/assets/ss1-1.png"),require("@/assets/ss1-2.png"),require("@/assets/ss1-3.png"),require("@/assets/ss1-4.png")],
        [require("@/assets/ss2-1.png"),require("@/assets/ss2-2.png"),require("@/assets/ss2-3.png"),require("@/assets/ss2-5.png"),require("@/assets/ss2-4.png")],
        [require("@/assets/ss3-1.png"),require("@/assets/ss3-2.png")],
        [require("@/assets/ss4-1.png")],
        [require("@/assets/ss5-1.png"),require("@/assets/ss5-2.png")],
      ],
      h6:['模式','深度','增益','体表标记','速度标尺和基线','角度校正','测量'],
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.wWidth = window.innerWidth;
    }
  },
  created(){

  }
}
</script>

<style lang="scss" scoped>
.device-ct {
  width: 100%;
  padding: 1rem;
  margin-top: 80px;
  background: linear-gradient(180deg, #f0f6ff 0%, #ffffff 100%);
  box-sizing: border-box;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

  @media (max-width: 767px) {
    margin-top: 60px;
    padding: 0.5rem;
  }

  .nav {
    width: 60%;
    margin: 0 auto;
    border: none;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(10px);
    box-shadow: 0 20px 60px rgba(37, 75, 156, 0.10),
                0 8px 24px rgba(37, 75, 156, 0.06);
    transition: all 0.3s ease;
    overflow: hidden;
    margin-top: 20px;

    @media (max-width: 1024px) {
      width: 80%;
    }
    @media (max-width: 767px) {
      width: 100%;
      border-radius: 16px;
      box-shadow: 0 12px 40px rgba(37, 75, 156, 0.08);
    }

    &:hover {
      box-shadow: 0 24px 72px rgba(37, 75, 156, 0.14);
    }
  }

  .module-title {
    padding: 2.5rem 2rem 1.5rem;
    font-size: 1.75rem;
    font-weight: 700;
    color: #1a365d;
    text-align: center;
    letter-spacing: 0.04em;
    position: relative;
    background: linear-gradient(135deg, #f8faff 0%, #eef4ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;

    h1 {
      margin: 0;
      font-size: inherit;
      font-weight: inherit;
    }

    @media (max-width: 767px) {
      font-size: 1.25rem;
      padding: 1.5rem 1rem 1rem;
      gap: 8px;
    }

    &::after {
      content: "";
      width: 100px;
      height: 4px;
      background: linear-gradient(90deg, #2563eb, #60a5fa, #2563eb);
      border-radius: 4px;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .ct-content {
    padding: 2.5rem 3rem 3rem;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    gap: 48px;

    @media (max-width: 1024px) {
      padding: 2rem 2rem 2.5rem;
      gap: 36px;
    }
    @media (max-width: 767px) {
      padding: 1.5rem 1rem 1.5rem;
      gap: 28px;
    }
  }

  .single-col-card {
    background: #fff;
    display: flex;
    flex-direction: column;
    gap: 32px;
    width: 100%;
    margin: auto;
  }

  // 全局统一标准文字样式（全系列页面共用）
  .text-content {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 0.95rem;
    line-height: 2;
    color: #1e293b;
    text-align: justify;
    letter-spacing: 0.01em;
    position: relative;
    padding-left: 1rem;
    border-left: 3px solid transparent;

    @media (max-width: 767px) {
      font-size: 0.85rem;
      line-height: 1.85;
      padding-left: 0.75rem;
    }

    &:first-of-type {
      margin-bottom: 2rem;
      border-left-color: #3b82f6;
      background: linear-gradient(90deg, rgba(59, 130, 246, 0.04) 0%, transparent 100%);
      padding: 0.75rem 1rem 0.75rem 1.5rem;
      border-radius: 0 8px 8px 0;

      @media (max-width: 767px) {
        padding: 0.5rem 0.75rem 0.5rem 1rem;
      }
    }

    &:last-of-type {
      margin-bottom: 2rem;
      border-left-color: #3b82f6;
      background: linear-gradient(90deg, rgba(139, 92, 246, 0.04) 0%, transparent 100%);
      padding: 0.75rem 1rem 0.75rem 1.5rem;
      border-radius: 0 8px 8px 0;

      @media (max-width: 767px) {
        padding: 0.5rem 0.75rem 0.5rem 1rem;
      }
    }
  }

  // CardBorder 内部穿透样式保留原有业务布局
  :deep .cardBorder .content .list:first-of-type{
      .el-row{
          display: flex;
      }
  }
  :deep .cardBorder .content .list:nth-of-type(2){
      .el-row{
          display: flex;
          flex-wrap: wrap;
      }
  }
  :deep .cardBorder .content .list{
      .el-row{
          text-align: left;
          padding-left: 70px;
          padding-right: 111px;
      }
  }
  :deep .cardBorder .content .list:nth-of-type(5){
      .el-row{
          padding-right: 0;
      }
  }
  :deep .cardBorder .content .list .el-col{
      text-align: left;
  }

  // ImgCol 图片自定义尺寸
  :deep .imgCom{
      height: 191px;
  }
  :deep .imgLimit{
      height: auto;
  }
  :deep .imgCom,
  :deep .imgLimit{
      width: auto;
      max-width: auto;
      max-height: auto;
      img{
          width: auto !important;
          height: auto !important;
          loading: lazy;
      }
  }

  // ImgCol 通用hover样式统一全系列
  :deep(.imgCom) {
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
    margin-bottom: 14px;
  }
  :deep(.imgCom:hover) {
    transform: translateY(-3px);
    box-shadow: 0 10px 26px rgba(10, 40, 70, 0.12);
  }
  :deep(.imgCom img) {
    transition: transform 0.4s ease;
  }
  :deep(.imgCom:hover img) {
    transform: scale(1.04);
  }
}

// 大屏适配
@media only screen and (max-width: 1700px){
  .device-ct{
    :deep .cardBorder .content .list:first-of-type{
        .el-row{
            display: inherit;
        }
    }
    :deep .cardBorder .content .list:nth-of-type(2){
        .el-row{
            justify-content: flex-start;
        }
    }
    :deep .cardBorder .content .list{
        .el-row{
            text-align: inherit;
            padding-right: 0;
        }
    }
    :deep .imgCom,
    :deep .imgLimit{
        img{
            width: 100% !important;
            height: 100% !important;
            loading: lazy;
        }
    }
  }
}

// 暗色模式完整适配
@media (prefers-color-scheme: dark) {
  .device-ct {
    background: linear-gradient(180deg, #0f1724 0%, #0a0f1a 100%);

    .nav {
      background: rgba(20, 30, 50, 0.92);
      backdrop-filter: blur(12px);
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);

      .module-title {
        color: #93bbfc;
        background: linear-gradient(135deg, #0f1a2e 0%, #162035 100%);
        &::after {
          background: linear-gradient(90deg, #1d4ed8, #60a5fa, #1d4ed8);
        }
      }

      .ct-content {
        background: #0f1a2e;

        .single-col-card {
          background: #142033;
        }
        .text-content {
          color: #c8d6e8;
          &:first-of-type {
            background: linear-gradient(90deg, rgba(59, 130, 246, 0.08) 0%, transparent 100%);
          }
          &:last-of-type {
            background: linear-gradient(90deg, rgba(139, 92, 246, 0.08) 0%, transparent 100%);
          }
        }
        :deep(.imgCom) {
          background: #142033;
        }
      }
    }
  }
}

// 全局导航统一穿透样式
:deep .global-nav[data-v-5e75b752]{
    background: none;
    border: none;
    box-shadow: none;
    padding: 0 0;
    width: 100%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}
:deep .global-nav .nav-item .nav-title.active[data-v-5e75b752]:hover {
  color: #0f3059;
  background: transparent;
}
</style>